import { useRef, useState } from 'react';
import { AddEntityDrawerProps } from 'components/IAP/EntityListProps';
import { useCreateNotification } from 'hooks/useNotification';
import { useParams } from 'react-router';
import { Button } from '@/components/ui/button';
import { FormModal } from '@/components/ui/form-modal';
import NotificationComposeFields, {
  NotificationComposeHandle,
} from './NotificationComposeFields';

const NewNotificationDrawer: React.FC<AddEntityDrawerProps> = ({ toggle }) => {
  const { incidentId } = useParams<{ incidentId: string }>();
  const createNotificationMutation = useCreateNotification();
  const composeRef = useRef<NotificationComposeHandle>(null);
  const [deliveryMode, setDeliveryMode] = useState<'now' | 'schedule'>('now');

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const collected = composeRef.current?.collect();
    if (!collected || collected.status !== 'ready') return;
    await createNotificationMutation.mutateAsync(collected.fields);
    toggle();
  };

  return (
    <FormModal
      open
      onOpenChange={(open) => {
        if (!open) toggle();
      }}
      title="Create Notification"
      widthClassName="tw:!max-w-5xl tw:sm:!max-w-5xl"
      formProps={{ onSubmit }}
      footer={
        <>
          <Button type="button" variant="outline" onClick={() => toggle()}>
            Close
          </Button>
          <Button type="submit" disabled={createNotificationMutation.isPending}>
            {deliveryMode === 'schedule' ? 'Schedule' : 'Send'}
          </Button>
        </>
      }
    >
      <NotificationComposeFields
        ref={composeRef}
        incidentId={incidentId}
        onDeliveryMode={setDeliveryMode}
      />
    </FormModal>
  );
};

export default NewNotificationDrawer;
